export class annualReportModel {
  ngo_id: string = null;
  report_title: string = null;
  report_url: string = null;

  constructor(obj?: any) {
    if (obj) {
      Object.keys(this).forEach((key) => {
        if (obj.hasOwnProperty(key)) {
          this[key] = obj[key];
        }
      });
    }
  }
}
export class ngoAwardModel {
  ngo_id: string = null;
  award_name: string = null;
  year: string = null;
  participant: string = null;

  constructor(obj?: any) {
    if (obj) {
      Object.keys(this).forEach((key) => {
        if (obj.hasOwnProperty(key)) {
          this[key] = obj[key];
        }
      });
    }
  }
}
